import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m13.174 2.453-8.14-1.437a1 1 0 0 0-1.159.81L2.015 12.39a1 1 0 0 0 .813 1.159l8.14 1.437a1 1 0 0 0 1.16-.812L13.987 3.61a1 1 0 0 0-.813-1.157M11.14 14 3 12.563 4.86 2 13 3.438zM5.584 3.651a.5.5 0 0 1 .58-.405l5.187.916a.5.5 0 1 1-.175.985L5.99 4.23a.5.5 0 0 1-.405-.58m-.347 1.97a.5.5 0 0 1 .58-.405l5.187.916a.5.5 0 1 1-.175.985L5.64 6.2a.5.5 0 0 1-.404-.58M4.89 7.59a.5.5 0 0 1 .579-.404l2.592.456a.5.5 0 1 1-.173.985L5.295 8.17a.5.5 0 0 1-.404-.58" }, null, -1)
  ]))]))
}
export default { render: render }